import React from "react";
import useHeaderMenuStore from '@src/stores/HeaderMenuStore';

export function HeaderActionAccount({ settings, isMobile }) {

    const { section } = settings;

    // Assuming we have a test variable for customer name
    const customerName = settings.globals.customer_name;
    const customerInitials = customerName.trim()[0];


    let isCustomerLoggedIn = settings.globals.is_customer_logged_in;
    let showInitials = false;
    const text_style = section.header_font_type;

    const openMenu = useHeaderMenuStore((state) => state.openMenu)

    return (
        <>
            {isCustomerLoggedIn && !section.show_account_popup_logged_in && !isMobile && (
                <div
                    className="header-action__link account-default-popup account-icon antialiased [&>svg]:h-[28px] no-underline cursor-pointer">
                    {section.account_popup_trigger == "click" && showInitials && !isMobile ? (
                        <div
                            className="flex items-center justify-center text-[16px] bg-[#000000] rounded-full text-white w-[30px] h-[30px] uppercase"
                            x-on:click="$nextTick(() => { $dispatch('toggle-display',{ message: 'header-account' }) })">
                            <span>{customerInitials}</span>
                        </div>
                    ) : !isMobile && (
                        <i className={`${settings.section.account_icon}  w-[16px] h-[16px]`}
                           x-on:click="$nextTick(() => { $dispatch('toggle-display',{ message: 'header-account' }) })">
                        </i>
                    )}
                </div>
            )}

            {isCustomerLoggedIn &&
                !isMobile &&
                section.show_account_popup_logged_in &&
                section.use_account_popup &&
                section.account_popup_trigger == "hover"  && (
                    section.show_text_no_icons_account ? (
                        <div className="header-action__link account-hover-popup flex account-icon antialiased [&>svg]:h-[28px]"
                             // x-on:mouseenter="$store.global.toggleAccountPopup()"
                             onMouseEnter={() => openMenu("ACCOUNT")}
                        >
                            <a href="/account" className={`${text_style}`}>ACCOUNT</a>
                        </div>
                    ) : (
                        <div className="account-hover-popup account-icon antialiased [&>svg]:h-[28px]"
                            onMouseEnter={() => openMenu("ACCOUNT")}
                        >
                            <i className={`${settings.section.account_icon}  w-[16px] h-[16px]`}></i>
                        </div>
                    )
                )}

            {!isCustomerLoggedIn &&
                !isMobile &&
                settings.section.use_account_popup &&
                settings.section.account_popup_trigger == "hover"  && (
                    section.show_text_no_icons_account ? (
                        <div className="header-action__link account-hover-popup flex account-icon antialiased [&>svg]:h-[28px]"
                            onMouseEnter={() => openMenu("ACCOUNT")}
                        >
                            <a href="/account" className={`${text_style}`}>ACCOUNT</a>
                        </div>
                    ) : (
                        <div className="account-hover-popup account-icon antialiased [&>svg]:h-[28px]"
                            onMouseEnter={() => openMenu("ACCOUNT")}
                        >
                            <i className={`${settings.section.account_icon}  w-[16px] h-[16px]`}></i>
                        </div>
                    )
                )}

            {!isCustomerLoggedIn &&
                !isMobile &&
                settings.section.use_account_popup &&
                settings.section.account_popup_trigger == "click" && (
                    section.show_text_no_icons_account ? (
                        <a href="/account" className={`flex ${text_style}`}>ACCOUNT</a>
                    ) : (
                        <a href="/account" className="account-icon antialiased [&>svg]:h-[28px]">
                            <i className={`${settings.section.account_icon} w-[16px] h-[16px]`}></i>
                        </a>
                    )
                )}

            {!isCustomerLoggedIn &&
                !isMobile &&
                !settings.section.use_account_popup && (
                    section.show_text_no_icons_account ? (
                        <a href="/account" className={`flex ${text_style}`}>ACCOUNT</a>
                    ) : (
                        <a href="/account" className="account-icon antialiased [&>svg]:h-[28px]">
                            <i className={`${settings.section.account_icon} w-[16px] h-[16px]`}></i>
                        </a>
                    )
                )}
        </>
    );
}
